export default __webpack_public_path__ + "static/media/Scanning.0e0149a2.svg";